//
// client-mgmt-create-form.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/* jshint devel: true */
/* global angular: false, _: false */

((() => {
    angular.module('curalate').directive('clientMgmtCreateForm',
        ['ClientMgmtApiService', 'ClientMgmtPageState', (ClientMgmtApiService, ClientMgmtPageState) => ({
            restrict: 'E',
            templateUrl: '/app/components/client-mgmt/create/client-mgmt-create-form.html',
            scope: {},

            controller: ['$scope', $scope => {
                // Scope bound functions and variables
                $scope.model = {

                    // General page state: success, error, outstandingRequests
                    pageState: ClientMgmtPageState,

                    // selectable fields
                    funnelStages: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'funnelStages'),
                    groups: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'groups'),
                    bvRegions: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'bvRegions'),
                    bvClientIds: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'bvClientIds'),

                    // other form fields
                    brandName: null,
                    ingestionEmailAddress: null,
                    suggestedEmailAddress: null,
                    useSuggestedEmailAddress: true,
                    newGroupName: null,
                    newGroupAdminFirstName: null,
                    newGroupAdminLastName: null,
                    newGroupAdminEmail: null,
                    curCreateInProgress: false,
                    bvClientId: null,
                    bvDisplayName: null,
                    salesforceId: null,
                    billingId: null,
                    bvCluster: null,
                    createBVclient: null,
                    jiraTicket: null,
                    useBVInstanceName: false,
                    bvActionComplete: false,
                    selectService: 'yes',
                    bvCreateComplete: false,
                    bvCreateInProgress: false,
                    continueToNextStep: false,
                    doesGroupAlreadyExist: false,
                };
            }],

            link(scope, element, attributes, controller) {
                scope.model.submit = () => {
                    let groupName;
                    let newGroupAdminCreateNewUser;
                    let createNewGroup;

                    scope.model.pageState.startAsyncAction();

                    // sanitize the request, but allow the error checking
                    // to be handled at the server to keep it all in one
                    // location (since incurring the round-trip penalty
                    // to discover it is worth it)
                    createNewGroup = scope.model.groups.isCreateNewIndicatorSelected();
                    if (createNewGroup) {
                        groupName = scope.model.newGroupName;
                        newGroupAdminCreateNewUser = true;
                    } else {
                        groupName = scope.model.groups.getSelected();
                        newGroupAdminCreateNewUser = null;
                        scope.model.newGroupName = null;
                        scope.model.newGroupAdminFirstName = null;
                        scope.model.newGroupAdminLastName = null;
                        scope.model.newGroupAdminEmail = null;
                    }

                    const ingestionEmailAddress = scope.model.useSuggestedEmailAddress ? scope.model.suggestedEmailAddress : scope.model.ingestionEmailAddress;

                    scope.model.curCreateInProgress = true;
                    // fire off the rpc request to create the client
                    ClientMgmtApiService.asyncCreateClient(
                        scope.model.funnelStages.getSelected(),
                        scope.model.brandName,
                        createNewGroup,
                        groupName,
                        newGroupAdminCreateNewUser,
                        scope.model.newGroupAdminFirstName,
                        scope.model.newGroupAdminLastName,
                        scope.model.newGroupAdminEmail,
                        ingestionEmailAddress,
                        scope.model.bvClientId,
                        scope.model.bvDisplayName,
                        scope.model.bvCluster,
                        scope.model.salesforceId,
                        scope.model.billingId
                    ).then(details => {
                        scope.model.curCreateInProgress = false;
                        scope.model.pageState.setSuccess(`Successfully created client with id ${details.clientId}!`);
                        scope.model.clientId = details.clientId;
                    }).catch(err => {
                        scope.model.curCreateInProgress = false;
                        scope.model.pageState.setError(`Error creating the client with info: Brand Name: ${scope.model.brandName} and BV Instance: ${scope.model.bvClientId}. ${err}`);
                    });
                };

                const retrieveBVClientRecord = (clientId, serviceName) => {
                    ClientMgmtApiService.asyncGetBVClientRecord(clientId, serviceName)
                        .then(clientRecord => {
                            scope.model.bvClientId = clientId;
                            scope.model.bvDisplayName = clientRecord.displayName;
                            scope.model.bvCluster = clientRecord.cluster;
                            scope.model.salesforceId = clientRecord.salesforceAccountId;
                            scope.model.bvActionComplete = true;
                            scope.model.pageState.clearResults();
                        })
                        .catch(err => {
                            scope.model.bvActionComplete = false;
                            scope.model.pageState.setError(`Error: ${err}`);
                        });
                };

                const retrieveAnyBVClientRecord = (clientId) => {
                    ClientMgmtApiService.asyncGetAnyBVClientRecord(clientId)
                        .then(clientRecord => {
                            scope.model.bvClientId = clientId;
                            scope.model.bvDisplayName = clientRecord.displayName;
                            scope.model.bvCluster = clientRecord.cluster;
                            scope.model.salesforceId = clientRecord.salesforceAccountId;
                            scope.model.bvActionComplete = true;
                            scope.model.pageState.clearResults();
                        })
                        .catch(err => {
                            scope.model.bvActionComplete = false;
                            scope.model.pageState.setError(`Error: ${err}`);
                        });
                };

                scope.model.getBVClientRecord = () => {
                    if (scope.model.selectService === 'CV2' && scope.model.bvClientIds.selectedItem != null) {
                        retrieveBVClientRecord(scope.model.bvClientIds.selectedItem, scope.model.selectService)
                    } else if (scope.model.selectService === 'Connections' && scope.model.bvClientId != null) {
                        retrieveBVClientRecord(scope.model.bvClientId, scope.model.selectService)
                    } else if (scope.model.selectService === 'Curalate' && scope.model.bvClientId != null) {
                        retrieveAnyBVClientRecord(scope.model.bvClientId)
                    } else if (scope.model.selectService === 'prr' && scope.model.bvClientId != null) {
                        retrieveBVClientRecord(scope.model.bvClientId, scope.model.selectService)
                    } else {
                        scope.model.pageState.clearResults();
                    }
                };

                scope.model.createBVClientRecord = () => {
                    scope.model.bvCreateInProgress = true;
                    if (/^([a-zA-Z0-9_-]+){2,31}$/.test(scope.model.bvClientId)) {
                        ClientMgmtApiService.asyncCreateBVCurOnlyClient(
                            scope.model.bvClientId,
                            scope.model.bvDisplayName,
                            scope.model.bvRegions.getSelectedId(),
                            scope.model.salesforceId,
                            scope.model.billingId
                        ).then(bvInstanceDetails => {
                            scope.model.bvCluster = bvInstanceDetails.cluster;
                            scope.model.jiraTicket = bvInstanceDetails.jiraTicket;
                            scope.model.bvActionComplete = true;
                            scope.model.bvCreateComplete = true;
                            scope.model.pageState.clearResults();
                            scope.model.bvCreateInProgress = false;
                        }).catch(err => {
                            scope.model.bvCreateInProgress = false;
                            scope.model.bvActionComplete = false;
                            scope.model.bvCreateComplete = false;
                            scope.model.pageState.setError(`Error triggering provisioning of the bv client instance: ${err}`);
                        });
                    } else if (scope.model.salesforceId.length !== 18) {
                        scope.model.bvCreateInProgress = false;
                        scope.model.bvActionComplete = false;
                        scope.model.bvCreateComplete = false;
                        scope.model.pageState.setError('Error occurred: Salesforce ID is required and must be 18 characters.');
                    } else {
                        scope.model.bvCreateInProgress = false;
                        scope.model.bvActionComplete = false;
                        scope.model.bvCreateComplete = false;
                        scope.model.pageState.setError('Error occurred: Instance name is invalid. Instance name must be between 2 and 31 characters and only contain alpha characters, numbers, dash and underscores');
                    }
                };

                const getBVClients = () => {
                    ClientMgmtApiService.asyncSearchBVClients()
                        .then(clients => {
                            scope.model.bvClientIds.itemNames = clients.values;
                        });
                };

                const getBVRegions = () => {
                    ClientMgmtApiService.asyncGetRegions()
                        .then(regions => {
                            const itemNames = [];
                            const map = {};
                            for (let i = 0; i < regions.regions.length; i++) {
                                itemNames.push(regions.regions[i].description);
                                map[regions.regions[i].description] = regions.regions[i].ID;
                            }
                            scope.model.bvRegions.itemNames = itemNames;
                            scope.model.bvRegions.map = map;
                        });
                };

                // initialize
                scope.model.pageState.init();
                getBVClients();
                getBVRegions();
                scope.model.groups.setCreateNewIndicator('Create New Group');
                scope.model.groups.populate(ClientMgmtApiService.asyncGetGroups);
                scope.model.funnelStages.defaultItem = 'Marketing';
                scope.model.funnelStages.populate(() => ClientMgmtApiService.asyncGetFunnelStages('create'));
                scope.model.pageState.initFinished();

                const updateSuggestedIngestionEmail = () => {
                    if (scope.model.brandName) {
                        ClientMgmtApiService.asyncBuildIngestionEmailAddress(scope.model.brandName).then(resp => {
                            scope.model.suggestedEmailAddress = resp.ingestionEmailAddress;
                        }).catch(err => {
                            scope.model.pageState.setError(`Error retrieving default ingestion email address: ${err}`);
                        });
                    }
                };

                const checkSuggestedEmailAddressAvailable = () => {
                    ClientMgmtApiService.asyncGetIngestionEmailAddressAvailability(scope.model.suggestedEmailAddress).then(resp => {
                        if (resp.available) {
                            scope.model.pageState.clearResults();
                            scope.model.continueToNextStep = true;
                        } else {
                            scope.model.continueToNextStep = false;
                            scope.model.pageState.setError('Suggested ingestion email address is not available. Please enter a custom email address.');
                        }
                    });
                };

                const checkCustomIngestionEmailAddressAvailable = () => {
                    ClientMgmtApiService.asyncGetIngestionEmailAddressAvailability(scope.model.ingestionEmailAddress).then(resp => {
                        if (resp.available) {
                            scope.model.pageState.clearResults();
                            scope.model.continueToNextStep = true;
                        } else {
                            scope.model.continueToNextStep = false;
                            scope.model.pageState.setError('Provided ingestion email address is not available. Please choose a different address.');
                        }
                    });
                };


                scope.$watch('model.brandName', updateSuggestedIngestionEmail);
                scope.$watch('model.ingestionEmailAddress', checkCustomIngestionEmailAddressAvailable);
                scope.$watch('model.suggestedEmailAddress', () => {
                    if (scope.model.useSuggestedEmailAddress) {
                        // only need to check if custom address is available if they've chosen to use it
                        checkSuggestedEmailAddressAvailable();
                    }
                });
                scope.$watch('model.useSuggestedEmailAddress', (newVal, oldVal) => {
                    if (newVal && !oldVal) {
                        // if useSuggestedEmailAddress is changed back to true, check if its available
                        checkSuggestedEmailAddressAvailable();
                    }
                });
                updateSuggestedIngestionEmail();

                const pacmanHealthCheck = () => {
                    if (scope.model.createBVclient === 'yes') {
                        ClientMgmtApiService.asyncPacmanHealthCheck()
                            .then(serviceOK => {
                                if (serviceOK === true || serviceOK === 'true') {
                                    scope.model.pageState.clearResults();
                                }
                            })
                            .catch(err => {
                                scope.model.pageState.setError(`Pacman health check failed: ${err}`);
                            });
                    }
                };

                const rosettaHealthCheck = () => {
                    ClientMgmtApiService.asyncRosettaHealthCheck()
                        .then(serviceOK => {
                            if (serviceOK === true || serviceOK === 'true') {
                                scope.model.pageState.clearResults();
                            }
                        })
                        .catch(err => {
                            scope.model.pageState.setError(`Rosetta health check failed: ${err}`);
                        });
                };
                scope.$watch('model.bvClientId', pacmanHealthCheck);
                scope.$watch('model.bvClientId', rosettaHealthCheck);
                scope.$watch('model.bvClientIds.selectedItem', pacmanHealthCheck);
                scope.$watch('model.bvClientIds.selectedItem', rosettaHealthCheck);

                const checkBVClientRecordDoesNotExist = () => {
                    if (scope.model.createBVclient === 'yes' && scope.model.bvClientId != null) {
                        ClientMgmtApiService.asyncDoesBVClientExist(scope.model.bvClientId)
                           .then(exists => {
                               if (exists === true || exists === 'true') {
                                   scope.model.useBVInstanceName = false;
                                   scope.model.pageState.setError('BV Client already exists');
                               } else {
                                   scope.model.useBVInstanceName = true;
                                   scope.model.pageState.clearResults();
                               }
                           })
                            .catch(err => {
                                scope.model.pageState.setError('Error occurred: Instance name is invalid. Instance name must be between 2 and 31 characters and only contain alpha characters, numbers, dash and underscores');
                            });
                    } else {
                        scope.model.pageState.clearResults();
                    }
                };
                scope.$watch('model.bvClientId', checkBVClientRecordDoesNotExist);

                const doesBVClientExist = (clientId) => {
                    ClientMgmtApiService.asyncDoesBVClientExist(clientId)
                        .then(exists => {
                            if (exists === true || exists === 'true') {
                                scope.model.useBVInstanceName = true;
                                scope.model.pageState.clearResults();
                            } else {
                                scope.model.useBVInstanceName = false;
                                scope.model.pageState.setError('BV Client does not exist');
                            }
                        })
                        .catch(err => {
                            scope.model.pageState.setError('Error occurred: Instance name is invalid. Illegal character. Instance name must only contain alpha characters, numbers, dash and underscores');
                        });
                };

                const checkBVClientRecordExists = () => {
                    if (scope.model.selectService === 'Connections' && scope.model.bvClientId != null) {
                        doesBVClientExist(scope.model.bvClientId);
                    } else if (scope.model.selectService === 'Curalate' && scope.model.bvClientId != null) {
                        doesBVClientExist(scope.model.bvClientId);
                    } else if (scope.model.selectService === 'prr' && scope.model.bvClientId != null) {
                        doesBVClientExist(scope.model.bvClientId);
                    }
                    else {
                        scope.model.pageState.clearResults();
                    }
                };
                scope.$watch('model.bvClientId', checkBVClientRecordExists);

                const searchBVClientRecords = () => {
                    if (scope.model.createBVclient === 'no') {
                        ClientMgmtApiService.asyncSearchBVClients(scope.model.bvClientIds.selectedItem)
                            .then(clients => {
                                scope.model.bvClientIds.itemNames = clients.values;
                                if (clients.values.includes(scope.model.bvClientIds.selectedItem)) {
                                    scope.model.useBVInstanceName = true;
                                } else {
                                    scope.model.useBVInstanceName = false;
                                }
                            })
                            .catch(err => {
                                scope.model.useBVInstanceName = false;
                                scope.model.pageState.setError(`Error: ${err}`);
                            });
                    } else {
                        scope.model.pageState.clearResults();
                    }
                };
                scope.$watch('model.bvClientIds.selectedItem', searchBVClientRecords);

                const checkIfGroupExists = () => {
                    const groups = scope.model.groups;
                    const groupNames = groups && groups.itemNames;
                    scope.model.doesGroupAlreadyExist = groupNames.includes(scope.model.newGroupName);
                    if (scope.model.doesGroupAlreadyExist) {
                        scope.model.pageState.setError(`Error occurred: Group name: ${scope.model.newGroupName} already exists. 
                        Either select the existing Group name from the dropdown or use a different Group name.`);
                    }
                };

                scope.$watch('model.newGroupName', checkIfGroupExists);

                const resetBVFieldsAll = () => {
                    scope.model.bvRegions.selectedItem = null;
                    scope.model.bvClientIds.selectedItem = null;
                    scope.model.bvClientId = null;
                    scope.model.bvDisplayName = null;
                    scope.model.salesforceId = null;
                    scope.model.billingId = null;
                    scope.model.bvCluster = null;
                    scope.model.jiraTicket = null;
                    scope.model.useBVInstanceName = false;
                    scope.model.bvActionComplete = false;
                    scope.model.bvCreateInProgress = false;
                    scope.model.bvCreateComplete = false;
                    scope.model.selectService = 'CV2';
                };
                scope.$watch('model.createBVclient', resetBVFieldsAll);

                const resetBVFields = () => {
                    scope.model.bvRegions.selectedItem = null;
                    scope.model.bvClientIds.selectedItem = null;
                    scope.model.bvClientId = null;
                    scope.model.bvDisplayName = null;
                    scope.model.salesforceId = null;
                    scope.model.billingId = null;
                    scope.model.bvCluster = null;
                    scope.model.jiraTicket = null;
                    scope.model.useBVInstanceName = false;
                    scope.model.bvActionComplete = false;
                    scope.model.bvCreateInProgress = false;
                    scope.model.bvCreateComplete = false;
                };
                scope.$watch('model.selectService', resetBVFields);
            },
        })]);
}))();
